export const Master = 'all-master'
export const rolepermission = 'role_permission'
export const blogs = 'blogs'
export const OrderList = 'order-list'
export const TestPermission = 'test-permission'
export const Products = 'products'
export const Sales = 'sales'
export const Earrings = 'earrings'
export const Diamonds = 'diamonds'
export const Categories = 'categories'
export const Customers = 'customers'
export const ContentManagement = 'content_management'
export const CacheManagement = 'cache_management'
export const Widgets = 'widgets'
export const Attribute = 'attribute'
export const Report = 'report'
export const Newsletter = 'newsletter'
export const ContactForm = 'contact_form'
export const Coupons = 'coupons'
export const Marketing = 'marketing'
export const System = 'system'
export const Section = 'section'
